module.exports = __webpack_public_path__ + "media/old_images/intro-iphone-jamtland-3a2e8fa2.png";